import React from "react";
import { useAnnouncement } from "@/context/AnnouncementContext";
import FeatureAnnouncement from "./FeatureAnnouncement";
import NewFeatureBanner from "./NewFeatureBanner";

const AnnouncementManager: React.FC = () => {
  const {
    showFeatureAnnouncement,
    showFeatureBanner,
    dismissFeatureAnnouncement,
    dismissFeatureBanner,
    exploreStockFeature,
  } = useAnnouncement();

  return (
    <>
      {/* Feature Announcement Modal */}
      <FeatureAnnouncement
        isOpen={showFeatureAnnouncement}
        onClose={dismissFeatureAnnouncement}
        onExplore={exploreStockFeature}
      />

      {/* Feature Banner */}
      <NewFeatureBanner
        isVisible={showFeatureBanner}
        onDismiss={dismissFeatureBanner}
        onExplore={exploreStockFeature}
      />
    </>
  );
};

export default AnnouncementManager;
